import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clock-pause",
  "use": "icon-clock-pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-clock-pause\">\n  <path d=\"M20.885 13.043A9 9 0 1 0 12.5 21\" />\n  <path d=\"M12 7v5l3 2\" />\n  <path d=\"M17 17v5\" />\n  <path d=\"M21 17v5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol